/**
 * Labstep
 *
 * @module screens/Device/Show/Center
 * @desc Device Show Center
 */

import {
  Action,
  DeviceActionMenu,
} from 'labstep-web/components/Device/Action/Menu';
import { DeviceBreadcrumb } from 'labstep-web/components/Device/Breadcrumb';
import DeviceBookingManager from 'labstep-web/components/DeviceBooking/Manager';
import { EntityPrimaryInfoImage } from 'labstep-web/components/Entity/PrimaryInfo/Image';
import { EntityUserCard } from 'labstep-web/components/EntityUser/Card';
import { MetadataManagerContainer as MetadataManager } from 'labstep-web/components/Metadata/Manager';
import { InformationCard } from 'labstep-web/core/Card/Information';
import type React from 'react';
import styles from './styles.module.scss';
import type { IDeviceShowCenterProps } from './types';

export const DeviceShowCenter: React.FC<IDeviceShowCenterProps> = ({
  device,
}) => {
  return (
    <div id="device-show-screen" className={styles.container}>
      <InformationCard
        additionalActions={
          !device.is_template && <EntityUserCard entity={device} />
        }
        actionMenu={
          <DeviceActionMenu
            device={device}
            actions={[
              Action.set_template,
              Action.tag,
              Action.share,
              Action.duplicate,
              Action.delete,
              Action.transfer_ownership,
            ]}
          />
        }
        breadcrumb={<DeviceBreadcrumb device={device} />}
        primaryInfo={<EntityPrimaryInfoImage entity={device} />}
        secondaryInfo={<MetadataManager entity={device} />}
        bottom={
          !device.is_template && (
            <DeviceBookingManager device={device} />
          )
        }
      />
    </div>
  );
};
